import { render, staticRenderFns } from "./payBtn.vue?vue&type=template&id=e785658e&scoped=true"
import script from "./payBtn.vue?vue&type=script&lang=ts"
export * from "./payBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e785658e",
  null
  
)

export default component.exports